import React, { useEffect } from "react";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Home Page/Footer";
import "./Disclaimer.css";

const Disclaimer = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <div className="container-fluid disclaimer-page posp-layout-padding">
                <div className="row">
                    <div className="col-12">
                        <h1>Disclaimer</h1>

                        <p>
                            Vibe is committed to maintaining transparency and providing clear, fair, and unbiased information regarding insurance products and services. The content, data, and information available on this website/portal are of a general informational nature and are intended solely for reference purposes. While reasonable efforts are made to ensure accuracy and reliability, Vibe does not warrant the completeness or correctness of any information and shall not be held responsible for any discrepancies, errors, or omissions.
                        </p>

                        <p>
                            All information made available on this portal is subject to Vibe’s discretion and may be modified, updated, or withdrawn at any time without prior notice. Any material updates of public relevance will be communicated through the portal as appropriate. Although Vibe endeavours to maintain high standards of quality and accuracy, it does not assume legal liability for the content provided on the portal.
                        </p>

                        <p>
                            Vibe, including its employees, representatives, and partners, shall not be liable for any direct or indirect loss, damage, or consequence arising from reliance on or use of the information provided on this portal. Users are advised to exercise their independent judgment and discretion before acting on any information.
                        </p>

                        <p>
                            Insurance is a subject matter of solicitation and is subject to market risks. Customers are advised to carefully review and understand the terms, conditions, exclusions, and limitations of insurance products before making any decisions. Vibe shall not be liable, under any circumstances, for decisions taken based on the information presented on this portal.
                        </p>

                        <p>
                            Users are strongly encouraged to read all policy documents, benefit illustrations, and sales brochures in detail before concluding any transaction. The information provided on this portal is intended solely for insurance and financial awareness and does not constitute professional or legal advice.
                        </p>

                        <p>
                            Any transaction, association, or engagement undertaken through this portal shall be at the sole discretion and risk of the user. Unless explicitly stated, the owners and operators of the Vibe portal are not agents, corporate agents, intermediaries, or related parties of any insurer whose products may be displayed.
                        </p>

                        <p>
                            Policy comparisons, features, benefits, and quotations are based on information received from insurers or publicly available sources. While efforts are made to ensure accuracy, Vibe, its directors, shareholders, officers, and employees disclaim any liability for decisions made by users based on such information. Each prospect, investor, or policyholder is solely responsible for evaluating and accepting the consequences of their decisions.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Disclaimer;
